<script>
  import { Sections } from "../../lib/nav.js";
  import t from '../../translations/translator.js';
  import { getGame } from "../stores/GameStore.js";
  import Section from "../controls/Section.svelte";

  export let games = [];
  export let onNavigate = (section, params = {}) => {};
</script>

<div class="space-y-8 text-left">
    <Section title="{t("GamesOverview.main_title")}" subtitle="{t("GamesOverview.main_body")}">
        <div class="space-y-8 text-left">
        {#if games.length > 0}
            <ul class="space-y-2">
            {#each games as game}
                {@const base = getGame(game.gameId)}
                <li
                class="p-2 flex items-center space-x-3 cursor-pointer"
                on:click={() => onNavigate(Sections.GAMES_SETTINGS, { selectedUserGameId: game.id })}
                >
                <img src={base.image || "/icons/default_game.png"} alt="icon" class="w-16 h-16 rounded" />
                <div class="flex flex-col leading-tight">
                    <span class="font-semibold text-lg">{game.title || t("MenuUntitledGamePlaceholder")}</span>
                    <span class="text-sm text-gray-400">{base.name || `ID ${game.id}`}</span>
                </div>
                </li>
            {/each}
            </ul>
        {:else}
            <li class="p-2 italic text-gray-400 cursor-default">{t("MenuNoGamesPlaceholder")}</li>
        {/if}
        </div>
    </Section>
</div>